import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type DeleteCargoFunction = MutateFunction<TrpcInputs['deleteCargo'], TrpcOutputs['deleteCargo']>;
type UseDeleteCargo = UseMutateResource<DeleteCargoFunction>;

export const useDeleteCargo = (id: number): UseDeleteCargo => {
  const { mutateAsync, isLoading, error } = trpc.deleteCargo.useMutation();
  const handleDelete: DeleteCargoFunction = () => mutateAsync({ id } as any);

  return [handleDelete, isLoading, error?.message];
};
